<template>
    <div class="page-sms">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>管理系统</el-breadcrumb-item>
            <el-breadcrumb-item>{{
                $route.meta.breadcrumb
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="page-title">{{ $route.meta.title }}</h1>

        <div class="content-card">
            <div class="toolbar-row">
                <el-input
                    v-model="search"
                    class="flex-grow"
                    clearable
                    placeholder="搜索模板名称或内容关键词..."
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="onSearch"
                    @clear="onSearch"
                />
                <div class="toolbar-actions">
                    <el-button
                        class="btn-black"
                        type="primary"
                        @click="openCreateDialog"
                        >新增模板</el-button
                    >
                    <el-button
                        icon="el-icon-refresh"
                        circle
                        @click="fetchData"
                    />
                </div>
            </div>

            <el-table
                :data="tableData"
                v-loading="loading"
                stripe
                border
                style="width: 100%"
                height="60vh"
            >
                <el-table-column
                    align="center"
                    prop="templateName"
                    label="模板名称"
                />
                <el-table-column
                    align="center"
                    label="短信模板内容"
                    min-width="240"
                >
                    <template slot-scope="scope">
                        <span class="sms-content-box">{{
                            scope.row.templateContent
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="创建时间"
                />
                <el-table-column align="center" label="审核状态">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.reviewStatus === 0"
                            type="success"
                            size="small"
                            >已通过</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.reviewStatus === 1"
                            type="warning"
                            size="small"
                            >审核中</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.reviewStatus === 2"
                            type="success"
                            size="small"
                            >待生效</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.reviewStatus === -1"
                            type="danger"
                            size="small"
                            >已拒绝</el-tag
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="140"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.reviewStatus === 1"
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        />
                        <el-button
                            type="text"
                            class="text-danger-action"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        />
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-bar">
                <span class="pagination-info">共 {{ total }} 条</span>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @current-change="fetchData"
                />
            </div>
        </div>

        <el-dialog
            :title="isEdit ? '编辑短信模板' : '新建短信模板'"
            :visible.sync="createDialogVisible"
            width="580px"
            custom-class="create-sms-dialog"
            :close-on-click-modal="false"
            append-to-body
            @closed="onCreateDialogClosed"
        >
            <el-form
                ref="createForm"
                :model="formData"
                :rules="createFormRules"
                label-position="top"
                class="create-sms-form"
            >
                <el-form-item label="模板名称" prop="name">
                    <el-input
                        v-model="formData.name"
                        placeholder="例如：卡密发放通知"
                        class="template-name-input"
                    />
                </el-form-item>
                <el-form-item label="模板内容" prop="content">
                    <el-input
                        ref="contentInput"
                        v-model="formData.content"
                        type="textarea"
                        :rows="6"
                        placeholder="请输入短信内容"
                        resize="vertical"
                        class="template-content-input"
                    />
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input
                        v-model="formData.remark"
                        placeholder="请输入备注信息"
                        class="template-name-input"
                    />
                </el-form-item>
            </el-form>
            <span slot="footer" class="create-sms-footer">
                <el-button @click="createDialogVisible = false">取消</el-button>
                <el-button
                    class="btn-black"
                    type="primary"
                    :loading="createSubmitting"
                    @click="submitCreateTemplate"
                >
                    {{ isEdit ? '保存修改' : '保存模板' }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getSmsTemplateList,
    addSmsTemplate,
    delSmsTemplate,
    updateSmsTemplate,
    queryStatus
} from '@/api/sms'

export default {
    name: 'SmsTemplate',
    data() {
        return {
            search: '',
            loading: false,
            currentPage: 1,
            pageSize: 10,
            total: 0,
            sendDialogVisible: false,
            sendSubmitting: false,
            sendSmsContent: '',
            sendSelectedIds: [],
            createDialogVisible: false,
            createSubmitting: false,
            isEdit: false,
            editingTemplateId: null,
            formData: {
                name: '',
                content: '',
                remark: ''
            },
            createFormRules: {
                name: [
                    {
                        required: true,
                        message: '请输入模板名称',
                        trigger: 'blur'
                    }
                ],
                content: [
                    {
                        required: true,
                        message: '请输入模板内容',
                        trigger: 'blur'
                    }
                ],
                remark: [
                    { required: true, message: '请输入备注', trigger: 'blur' }
                ]
            },
            templateVars: [
                { label: '卡号', value: '{1}' },
                { label: '密码', value: '{2}' },
                { label: '客户姓名', value: '{3}' },
                { label: '手机号', value: '{4}' },
                { label: '金额', value: '{5}' }
            ],
            smsRecipients: [],
            tableData: []
        }
    },
    mounted() {
        this.onSearch()
    },
    computed: {},
    methods: {
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        async fetchData() {
            this.loading = true
            try {
                const result = await getSmsTemplateList({
                    templateName: this.search,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })
                this.tableData = result.rows
                this.total = result.total || 0
            } catch {
                this.$message.error('获取短信模板列表失败')
            } finally {
                this.loading = false
            }
        },
        insertVar(variable) {
            const textarea =
                this.$refs.contentInput.$el.querySelector('textarea')
            if (!textarea) {
                this.formData.content += variable
                return
            }
            const start = textarea.selectionStart
            const text = this.formData.content
            this.formData.content =
                text.substring(0, start) + variable + text.substring(start)
            this.$nextTick(() => {
                textarea.selectionStart = textarea.selectionEnd =
                    start + variable.length
                textarea.focus()
            })
        },
        openCreateDialog() {
            this.isEdit = false
            this.editingTemplateId = null
            this.formData = { name: '', content: '', remark: '' }
            this.$nextTick(() => {
                this.$refs.createForm && this.$refs.createForm.clearValidate()
            })
            this.createDialogVisible = true
        },
        async handleEdit(row) {
            try {
                const res = await queryStatus(row.templateId)
                const status = res.data?.reviewStatus ?? res.reviewStatus
                if (status !== 1) {
                    this.$message.warning('仅审核中的模板支持修改')
                    return
                }
            } catch {}
            this.isEdit = true
            this.editingTemplateId = row.templateId
            this.formData = {
                name: row.templateName || '',
                content: row.templateContent || '',
                remark: row.remark || ''
            }
            this.createDialogVisible = true
        },
        onCreateDialogClosed() {
            this.createSubmitting = false
            this.isEdit = false
            this.editingTemplateId = null
        },
        async submitCreateTemplate() {
            try {
                await this.$refs.createForm.validate()
            } catch {
                return
            }
            this.createSubmitting = true
            try {
                if (this.isEdit) {
                    await updateSmsTemplate({
                        templateId: this.editingTemplateId,
                        templateName: this.formData.name.trim(),
                        templateContent: this.formData.content.trim(),
                        remark: this.formData.remark.trim()
                    })
                    this.$message.success('修改成功')
                } else {
                    await addSmsTemplate({
                        templateName: this.formData.name.trim(),
                        templateContent: this.formData.content.trim(),
                        remark: this.formData.remark.trim()
                    })
                    this.$message.success('模板创建成功')
                }
                this.createDialogVisible = false
                this.currentPage = 1
                this.fetchData()
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.createSubmitting = false
            }
        },
        handleDelete(row) {
            this.$confirm(`确定删除模板「${row.templateName}」？`, '删除确认', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(async () => {
                    try {
                        await delSmsTemplate(row.templateId)
                        this.$message.success('删除成功')
                        this.fetchData()
                    } catch {
                        // 错误已在 request.js 响应拦截器中处理
                    }
                })
                .catch(() => {})
        },
        openSendDialog(row) {
            this.sendSmsContent = row.templateContent || ''
            this.sendSelectedIds = []
            this.sendDialogVisible = true
        },
        onSendDialogClosed() {
            this.sendSubmitting = false
        }
    }
}
</script>

<style scoped>
.btn-mini-send {
    padding: 7px 12px;
    margin-right: 4px;
}

.template-name-input {
    margin-bottom: 8px;
}

.template-content-input {
    margin-bottom: 8px;
}

.available-variables {
    font-size: 12px;
    color: #909399;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
}

.variable-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.var-label {
    font-size: 12px;
    color: #909399;
    margin-right: 2px;
}

.var-tag {
    display: inline-block;
    padding: 3px 10px;
    font-size: 12px;
    color: #409eff;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s;
    user-select: none;
}

.var-tag em {
    font-style: normal;
    color: #909399;
    margin-left: 4px;
    font-size: 11px;
}

.var-tag:hover {
    color: #fff;
    background: #409eff;
    border-color: #409eff;
}

.var-tag:hover em {
    color: rgba(255, 255, 255, 0.7);
}

.sms-preview {
    margin-top: 14px;
    padding: 14px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 6px;
}

.preview-title {
    font-size: 13px;
    font-weight: 600;
    color: #67c23a;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.preview-bubble {
    font-size: 14px;
    color: #303133;
    padding: 12px 14px;
    background: #fff;
    border-radius: 8px;
    line-height: 1.6;
    word-break: break-all;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.preview-bubble >>> .pv-var {
    font-style: normal;
    color: #e6a23c;
    font-weight: 600;
    padding: 1px 4px;
    background: #fdf6ec;
    border-radius: 2px;
}

.create-sms-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.create-sms-form >>> .el-form-item__label {
    padding-bottom: 6px;
    line-height: 1.3;
    font-weight: 500;
}

.recipient-list {
    max-height: 220px;
    overflow-y: auto;
    padding: 12px 14px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fafafa;
}

.recipient-checkbox {
    display: block;
    margin-left: 0;
    margin-bottom: 12px;
    white-space: normal;
    line-height: 1.5;
}

.recipient-checkbox:last-child {
    margin-bottom: 0;
}

.send-sms-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.send-sms-form >>> .el-form-item__label {
    padding-bottom: 6px;
    line-height: 1.3;
}

.pagination-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
}

.pagination-info {
    font-size: 13px;
    color: #606266;
}
</style>

<style>
.send-sms-dialog .el-dialog__body {
    padding-top: 8px;
    padding-bottom: 8px;
}

.create-sms-dialog .el-dialog__body {
    padding-top: 8px;
    padding-bottom: 8px;
}

.page-sms .el-table__fixed-right {
    background: #fff;
    border-left: 1px solid #ebeef5;
}
.page-sms .el-table__fixed-right td,
.page-sms .el-table__fixed-right th {
    background: #fff;
}
.page-sms .el-table__body-wrapper .el-table__fixed-right .el-table__body {
    border-left: 1px solid #ebeef5;
}
</style>